/**
 * Functional way of wrapping async functions in try/catch.
 * @example
 * const [error, result] = await tryCatch(() => myAsyncFunction(params))
 * if (error) {
 *   console.error('cannot call my async function', error.message)
 *   return
 * }
 * doSomethingMeaningfulWith(result)
 */
export const tryCatch = async fn => {
  try {
    const res = await fn();
    return [undefined, res];
  } catch (error) {
    return [error, undefined];
  }
};

/**
 * Synchronous analog of tryCatch
 */
export const tryCatchSync = fn => {
  try {
    const res = fn();
    return [undefined, res];
  } catch (error) {
    return [error, undefined];
  }
};
//# sourceMappingURL=tryCatch.js.map